import { FSM_STATES, FSM_STATE_TYPE } from './defaultState'
import { info } from '../services/sentryLogger'
import { PartialParameters } from '../parameters/types'

// FIXME refactor with base happy flow, then skip
export const getNextScreen = (
    currentScreen: FSM_STATE_TYPE,
    params: PartialParameters,
    isLastStm = false,
    isLastRound = false
): FSM_STATE_TYPE => {
    info('getNextScreen()', currentScreen, params)
    const { assessmentParams } = params
    if (assessmentParams.is360) {
        return getNextScreen360(currentScreen, params, isLastStm)
    } 
    // FIXME to validate
    // else if(assessmentParams.isQSortV2) {
    //     return getNextScreenQSortV2(currentScreen, params, isLastRound);
    // }
    switch (currentScreen) {
        // case FSM_STATES.NONE: FIXME required?
        case FSM_STATES.AUTH:
            if (assessmentParams.hasIntro) {
                return FSM_STATES.INTRO
            } else if (assessmentParams.has2ndBranding) {
                return FSM_STATES.BRANDING
            } else if (assessmentParams.hasHowTo) {
                return assessmentParams.isQSortV2 ? FSM_STATES.HOW_TO_Q_SORT : FSM_STATES.HOW_TO_BINARY
            } else {
                return assessmentParams.isQSortV2 ? FSM_STATES.QSORT_V2_RANKER : FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.INTRO:
            if (assessmentParams.has2ndBranding) {
                return FSM_STATES.BRANDING
            } else if (assessmentParams.hasHowTo) {
                return assessmentParams.isQSortV2 ? FSM_STATES.HOW_TO_Q_SORT : FSM_STATES.HOW_TO_BINARY
            } else {
                return assessmentParams.isQSortV2 ? FSM_STATES.QSORT_V2_RANKER : FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.BRANDING:
            if (assessmentParams.hasHowTo) {
                return assessmentParams.isQSortV2 ? FSM_STATES.HOW_TO_Q_SORT : FSM_STATES.HOW_TO_BINARY
            } else {
                return assessmentParams.isQSortV2 ? FSM_STATES.QSORT_V2_RANKER : FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.HOW_TO_Q_SORT:
        case FSM_STATES.HOW_TO_BINARY:
            return assessmentParams.isQSortV2 ? FSM_STATES.QSORT_V2_RANKER : FSM_STATES.RANK_14_X_BY_X
        case FSM_STATES.RANK_14_X_BY_X:
            if (!isLastStm) {
                return FSM_STATES.RANK_FOR_PROFILE
            }
            if (assessmentParams?.hasAwardRound) {
                return FSM_STATES.AWARD_ROUND
            } else if (assessmentParams?.hasConfirmRound) {
                return FSM_STATES.RANK_FOR_ROUND
            } else if (isLastRound) {
                if (assessmentParams?.hasHowToBuckets) {
                    return FSM_STATES.HOW_TO_BUCKETS
                } else {
                    return FSM_STATES.RANK_FOR_BUCKET
                }
            } else {
                return FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.RANK_FOR_PROFILE:
            return FSM_STATES.RANK_14_X_BY_X
        case FSM_STATES.AWARD_ROUND:
            if (assessmentParams?.hasConfirmRound) {
                return FSM_STATES.RANK_FOR_ROUND
            } else if (isLastRound) {
                if (assessmentParams?.hasHowToBuckets) {
                    return FSM_STATES.HOW_TO_BUCKETS
                } else {
                    return FSM_STATES.RANK_FOR_BUCKET
                }
            } else {
                return FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.RANK_FOR_ROUND:
            info('RANK_FOR_ROUND', 'FSM_STATES')
            if (isLastRound) {
                if (assessmentParams?.hasHowToBuckets) {
                    return FSM_STATES.HOW_TO_BUCKETS
                } else {
                    return FSM_STATES.RANK_FOR_BUCKET
                }
            } else {
                return FSM_STATES.RANK_14_X_BY_X
            }
        case FSM_STATES.HOW_TO_BUCKETS:
            return FSM_STATES.RANK_FOR_BUCKET
        case FSM_STATES.RANK_FOR_BUCKET:
            return FSM_STATES.FINAL_OVERVIEW
        default:
            return FSM_STATES.INTRO
    }
}

export const getNextScreen360 = (
    currentScreen: FSM_STATE_TYPE,
    params: PartialParameters,
    isLastStm: boolean
) => {
    const {
        assessmentParams: { is360WithLeadership, is360WithWorkenv },
    } = params
    switch (currentScreen) {
        case FSM_STATES.AUTH:
            // return FSM_STATES.HOW_TO_NPS
            return FSM_STATES.HOW_TO_360
        case FSM_STATES.HOW_TO_360:
            if (is360WithLeadership) {
                return FSM_STATES.PICKER_LEADERSHIP_360
            } else {
                return FSM_STATES.PICKER_WORKENV_360
            }
        case FSM_STATES.PICKER_LEADERSHIP_360:
            if (!isLastStm) return FSM_STATES.PICKER_LEADERSHIP_360
            if (is360WithWorkenv) {
                return FSM_STATES.HOW_TO_WORKENV
            } else {
                return FSM_STATES.NPS_360
            }
        // TODO Dans le V360, SI le Paramètre « écrans intermédiaires » est OFF (ne pas les voir), ALORS ne pas montrer « award1_body », « award2_body » & « award3_body » (ie la phrase explicative sur la page précédente)
        case FSM_STATES.HOW_TO_WORKENV:
            return FSM_STATES.PICKER_WORKENV_360
        case FSM_STATES.PICKER_WORKENV_360:
            if (!isLastStm) return FSM_STATES.PICKER_WORKENV_360
            return FSM_STATES.HOW_TO_NPS
        // FIXME
        // case FSM_STATES.PICKER_360:
        //     if (isLastStm) {
        //         return FSM_STATES.NPS_360
        //     } else {
        //         return FSM_STATES.PICKER_360
        //     }
        case FSM_STATES.HOW_TO_NPS:
            return FSM_STATES.NPS_360
        case FSM_STATES.NPS_360:
            return FSM_STATES.THANKS_360
        default:
            return FSM_STATES.AUTH
    }
}

// // TODO
// export const getNextScreenQSortV2 = (
//     currentScreen: FSM_STATE_TYPE,
//     params: PartialParameters,
//     isLastStm: boolean
// ) =>  FSM_STATES.QSORT_V2_RANKER;